<script setup>
import { Course } from '@pfsc/core/models/course';
import { CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID } from '@pfsc/core/models/package';
import { User } from '@pfsc/core/models/user';
import { useCoursesRequireDobStore } from '@pfsc/core/stores/courses-require-dob.store';
import { useTriggerStore } from '@pfsc/core/stores/trigger.store';
import { useDobDialog } from '@pfsc/core/ui-services/use-dob-dialog';
import { ref } from 'vue';
import RbsInfoDialog from '../rbs-info-dialog.vue';
import TransferCourseDialog from './transfer-course-dialog.vue';

const { isCourseRequireDob } = useCoursesRequireDobStore();
const trigger = useTriggerStore();
const { showDobDialogWithConfig, closeDobDialog } = useDobDialog();

const transferCourseDialogRef = ref(null);
const rbsInfoDialogRef = ref(null);

/** @type {import("vue").Ref<Course | null>} Course */
const selectedCourse = ref(null);

/** Handle dob submitted. */
function onUserInfoSubmitted() {
  closeDobDialog();
  rbsInfoDialogRef.value.closeDialog();
  transferCourseDialogRef.value.openDialog(selectedCourse.value);
  trigger.triggerRegistrationsChange();
}

/**
 * Open dialog.
 * @param {Course} course Course
 * @param {User} user User
 */
async function openDialog(course, user) {
  selectedCourse.value = course;
  const shouldOpenRbsDialog = course.registration.user.rbsServerId == null
    && course.package.id === CALIFORNIA_RESPONSIBLE_BEVERAGE_SERVICE_TRAINING_ID;
  if (shouldOpenRbsDialog) {
    rbsInfoDialogRef.value.openDialog(user);
    return;
  }
  const shouldOpenDobDialog = isCourseRequireDob(course.course) && course.registration.user.dob == null;
  if (shouldOpenDobDialog) {
    showDobDialogWithConfig({ userId: user.id, dob: null, onDobSubmitted: onUserInfoSubmitted });
    return;
  }
  transferCourseDialogRef.value.openDialog(course);
}

defineExpose({ openDialog });

</script>

<template>
  <rbs-info-dialog ref="rbsInfoDialogRef" @on-submitted="onUserInfoSubmitted" />
  <transfer-course-dialog ref="transferCourseDialogRef" />
</template>

<style lang="scss" scoped>

</style>
